module.exports = __webpack_public_path__ + "img/sim-prova.37821f03.png";